var _a;
import { FetchProvider } from './FetchProvider';
import { IndexedDBFetchProvider } from './IndexedDBFetchProvider';
import { UrlFetchProvider } from './UrlFetchProvider';
import { Providers } from 'formiojs';
var fetchProviders = (_a = {},
    _a[FetchProvider.key] = FetchProvider,
    _a[UrlFetchProvider.key] = UrlFetchProvider,
    _a[IndexedDBFetchProvider.key] = IndexedDBFetchProvider,
    _a);
Providers.addProviders('fetch', fetchProviders);
export default fetchProviders;
